document.addEventListener('DOMContentLoaded', function() {
    var nw_carousels = document.querySelectorAll('.nw-main-carousel');
    var resizeNwTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeNwTimer);
      resizeNwTimer = setTimeout(initNwCarousels, 250);
    });
  
    function initNwCarousels() {
      nw_carousels.forEach(function(carousel) {
        if (carousel.flickityInstance) {
          carousel.flickityInstance.destroy();
        }
  
        var groupCellsValue;
        var windowWidth = window.innerWidth;
        var blogSlider = carousel.querySelector('.carousel-cell-blog') !== null;       
  
  
        if (windowWidth >= 62.0625 * 16) { // 62.0625rem in pixels
          if(blogSlider){
            groupCellsValue = 3;
          }else{
            groupCellsValue = 4;
          }          
        } else if (windowWidth >= 41.4375 * 16) { // 41.4375rem in pixels;
          if(blogSlider){
            groupCellsValue = 2;
          }else{
            groupCellsValue = 3;
          }
        } else if (windowWidth >= 26.3125 * 16) { // 26.3125rem in pixels
          if(blogSlider){
            groupCellsValue = 2;
          }else{
            groupCellsValue = 2;
          }
        } else {
          if(blogSlider){
            groupCellsValue = 1;
          }else{
            groupCellsValue = 1; // default for smaller screens
          }   
        }
  
        carousel.flickityInstance = new Flickity(carousel, {
          cellAlign: 'center',
          contain: true,
          groupCells: groupCellsValue,
          prevNextButtons: true,
          pageDots: true,
          draggable: true,
          freeScroll: false,
          resize: true
        });
        
        if (carousel.classList.contains('title-below-image')) {
          nw_set_slides_height(carousel);
        }
      });
    }
      function nw_set_slides_height(carousel) {
      var max_title_height = 0;
      var titles = carousel.querySelectorAll('.carousel-cell-title');
      
      titles.forEach(function(title) {
        var title_height = title.offsetHeight;
        if (title_height > max_title_height) {
          max_title_height = title_height;
        }
      });
      var flickity_viewport = carousel.querySelector('.flickity-viewport');
      if (flickity_viewport) {
        flickity_viewport.style.height = (carousel.flickityInstance.maxCellHeight + max_title_height) + 'px';
      }
      var slider_images = carousel.querySelectorAll('.nw-carousel-image');
      slider_images.forEach(function(image) {
          image.style.height = carousel.flickityInstance.maxCellHeight + 'px';
      });
      var carousel_cells = carousel.querySelectorAll('.carousel-call__wrapper');
      carousel_cells.forEach(function(cell) {
          cell.style.height = (carousel.flickityInstance.maxCellHeight + max_title_height) + 'px';
      });
    }
    initNwCarousels();
});
  